const drafts = new Map();
/** Memory only: never persist OTPs, provider credentials, quotes or payment authority.
 * Hosts scope this key to the authenticated owner and backend environment.
 * Canonical eligibility and payer status are re-fetched on every reopen.
 */
export function checkoutProgress(key) {
    const now = Date.now();
    for (const [scope, entry] of drafts)
        if (entry.expiresAt <= now)
            drafts.delete(scope);
    const existing = drafts.get(key);
    if (existing)
        return existing.value;
    const value = {
        method: null,
        amountUnits: null,
        amountCurrency: null,
        amountDecimals: null,
        verificationRequested: false,
        verificationFromProfile: false,
        verificationFromLimit: false,
        contact: null,
        challenge: null,
        cooldowns: {},
        drafts: {},
    };
    drafts.set(key, { expiresAt: now + 30 * 60 * 1000, value });
    return value;
}
export function updateFundingAmount(progress, currency, decimals, update) {
    return (units) => {
        progress.amountUnits = units;
        progress.amountCurrency = currency;
        progress.amountDecimals = decimals;
        update(units);
    };
}
/** Sign-out discards all locally retained contact drafts; dismissal does not. */
export function clearCheckoutProgress(key) {
    for (const [scope, { value }] of drafts) {
        if (key !== undefined && scope !== key && !scope.startsWith(`${key}:`))
            continue;
        value.drafts = {};
        value.challenge = null;
        value.contact = null;
        value.cooldowns = {};
        value.method = null;
        value.amountUnits = null;
        value.amountCurrency = null;
        value.amountDecimals = null;
        value.verificationRequested = false;
        value.verificationFromProfile = false;
        value.verificationFromLimit = false;
        drafts.delete(scope);
    }
}
export function correctFundingAmount(options) {
    const { state, preview, amountUnits, progress, update } = options;
    const boundary = preview.providerFailure?.amountBoundary;
    if (state !== 'amount' ||
        preview.state !== 'error' ||
        preview.amountUnits !== amountUnits ||
        !boundary ||
        boundary.kind === 'minimum' ||
        boundary.amountUnits === amountUnits ||
        boundary.amountUnits === progress.amountUnits)
        return null;
    update(boundary.amountUnits);
    return boundary;
}
